import { authFetch, getSessionToken } from "site/services/auth-session.service";
import { subscriptionApiBaseUrl } from "site/services/xq-api-base-url";

export type OwnerPaymentRow = {
  id: number;
  book_id: number;
  book_title: string;
  email: string;
  amount_kopeks: number;
  status: "pending" | "paid" | "failed" | "cancelled" | string;
  provider: string;
  billing_region?: string;
  payment_provider_id?: string;
  receipt_email?: string;
  receipt_item_name?: string;
  receipt_taxation?: string;
  receipt_fiscal_document_number?: number | null;
  receipt_fiscal_sign?: string;
  receipt_url?: string;
  created_at: string;
  paid_at?: string | null;
  cancelled_at?: string | null;
  can_cancel: boolean;
};

function authHeaders(): Record<string, string> {
  const token = getSessionToken();
  if (!token) {
    return {};
  }
  return { Authorization: `Bearer ${token}` };
}

export async function fetchOwnerPayments(limit = 100): Promise<OwnerPaymentRow[]> {
  const base = subscriptionApiBaseUrl();
  if (!base || !getSessionToken()) {
    return [];
  }
  const response = await authFetch(`${base}/owner/payments?limit=${encodeURIComponent(String(limit))}`, {
    headers: authHeaders(),
  });
  if (!response.ok) {
    throw new Error(`owner payments: HTTP ${response.status}`);
  }
  const data = (await response.json()) as { payments?: OwnerPaymentRow[] };
  return Array.isArray(data.payments) ? data.payments : [];
}

export async function cancelOwnerPayment(paymentId: number): Promise<void> {
  const base = subscriptionApiBaseUrl();
  if (!base || !getSessionToken()) {
    throw new Error("no session");
  }
  const response = await authFetch(`${base}/owner/payments/${encodeURIComponent(String(paymentId))}/cancel`, {
    method: "POST",
    headers: authHeaders(),
  });
  if (!response.ok) {
    const detail = await response.text().catch(() => "");
    throw new Error(detail || `cancel payment: HTTP ${response.status}`);
  }
}
